import { InputStartDay } from '@/components/InputDay/InputStartDay'
import { yStack } from 'ui/src/patterns/stack'
import { AutoSwitchToggleCard } from './AutoSwitchToggleCard'

type Props = {
  requested: boolean
  onAutoSwitchChange?: (checked: boolean) => void
  companyName: string
  startDate?: Date
  minStartDate?: Date
  maxStartDate?: Date
  onStartDateChange: (date: Date) => void
  loading?: boolean
}

export const IEXCancellation = (props: Props) => {
  return (
    <div className={yStack({ gap: 'xxs' })}>
      <AutoSwitchToggleCard
        checked={props.requested}
        onCheckedChange={props.onAutoSwitchChange}
        companyName={props.companyName}
      />
      {!props.requested && (
        <InputStartDay
          date={props.startDate}
          minDate={props.minStartDate}
          maxDate={props.maxStartDate}
          onChange={props.onStartDateChange}
          loading={props.loading}
        />
      )}
    </div>
  )
}
